export const APPSTORE_URL = "https://apps.apple.com/app/id6746559910"
export const PLAYSTORE_BUNDLE_ID = "com.bayut.shorkaa.propforce"
export const INTENT_URI =
  "intent://details?id=com.bayut.shorkaa.propforce#Intent;scheme=market;package=com.bayut.shorkaa.propforce;end"
export const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=com.bayut.shorkaa.propforce"

// Social media URLs
export const FACEBOOK_URL = "https://www.facebook.com/bayutksa/"
export const TWITTER_URL = "https://x.com/BayutKSA"
export const LINKEDIN_URL = "https://www.linkedin.com/company/bayut-ksa"
export const INSTAGRAM_URL = "https://www.instagram.com/BayutKSA"
